/** @jsx jsx */
import type { Transformation } from 'cloudinary-core';
import { Cloudinary } from 'cloudinary-core';
import { jsx } from 'theme-ui';

const cl = new Cloudinary({ cloud_name: 'bottlebooks', secure: true });

type ConstrainedImageProps = React.ImgHTMLAttributes<HTMLImageElement> & {
  publicId: string | null;
  options: Transformation.Options;
};

export default function ConstrainedImage({
  publicId,
  options,
  ...rest
}: ConstrainedImageProps) {
  if (!publicId) return null;
  const src = cl.url(publicId, options);
  return (
    <img
      src={src}
      alt=""
      sx={{ maxWidth: options.width, height: 'auto', marginBottom: 'auto' }}
      {...rest}
    />
  );
}
